// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"loanApplicationCurrency_errorMessage__3Tsco"};